if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      this.initSlider();
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const tickerContainer = this.querySelector('.ticker-container');
      if (tickerContainer) {
        this.slider = new MinimogLibs.Swiper(tickerContainer, {
          slidesPerView: 'auto',
          loop: true,
          speed: 8000,
          allowTouchMove: false,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          spaceBetween: 0,
        });
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}
